/**
 * Dashboard Frontend - App Configuration Constants
 */

/** Default timeout for all outbound HTTP requests (ms) */
export const HTTP_TIMEOUT_MS = 30_000;

/**
 * Support contact address. Centralized per the config-constants convention so
 * swapping it is one edit, not a hunt across pages. Frontend env is public and
 * this is not a secret, so the env override is safe here.
 *
 * `||`, not `??`: an env var that is present but empty is a misconfiguration,
 * not a choice to have no support address, and `??` would keep the empty string
 * and mail nobody.
 */
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL || 'support@airclou.com';

/**
 * Public product documentation (the manual in `apps/hub`), not the customer
 * help center at `hc.airclou.com`.
 */
export const DOCUMENTATION_URL = import.meta.env.VITE_DOCUMENTATION_URL || 'https://airclou.com/docs';

/**
 * Where "Contact us" sends someone asking about an Enterprise tier, which is
 * priced by quote (docs/strategy/helpdesk-pricing-strategy.md §1).
 */
export const CONTACT_SALES_URL = import.meta.env.VITE_CONTACT_SALES_URL || 'https://airclou.com/contact';
